declare global {
  interface Window {
    heap?: {
      track: (eventName: string, eventParams: object) => void;
      identify: (id: string) => void;
    };
  }
}

export const useHeapTrack = (eventName: string, eventParams: object) => {
  if (window.location.hostname !== 'localhost') {
    if (window.heap && typeof window.heap.track === 'function') {
      try {
        window.heap.track(eventName, eventParams);
      } catch (error) {
        console.error('Error tracking heap event:', error);
      }
    } else {
      console.warn('Heap analytics not available');
    }
  }
};
